<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">
    <div>
      <button mat-stroked-button color="warn">Cerrar Ahora</button>
    </div>
    <section id="header">
      <h1 class="h1Header">ADMINISTRAR PRODUCTOS</h1>
    </section>

    <section id="table">
      <mat-card class="mat-elevation-z0">
        <div div fxLayout="row" fxLayoutAlign="end center">
          <button mat-flat-button class="export-btn" (click)="exporter.exportTable('xlsx')">Exportar
            Excel</button>
          <!--<button mat-flat-button class="upload-btn">Subir Excel</button>-->
          <button mat-flat-button class="add-btn" (click)="addProduct()">Agregar nuevo</button>
        </div>

        <table mat-table matTableExporter [dataSource]="allItems" class="mat-elevation-z0" #exporter="matTableExporter"
          [hiddenColumns]="[4,5,6]">
          <ng-container matColumnDef="imagen">
            <th mat-header-cell *matHeaderCellDef class="table-header">IMAGEN</th>
            <td mat-cell *matCellDef="let item" class="table-content"> <img class="table-image" [src]="item.dsImg" />
            </td>
          </ng-container>

          <ng-container matColumnDef="categoria">
            <th mat-header-cell *matHeaderCellDef class="table-header">CATEGORÍA</th>
            <td mat-cell *matCellDef="let item" class="table-content">{{item.itemCategoryName}}</td>
          </ng-container>

          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef class="table-header">NOMBRE</th>
            <td mat-cell *matCellDef="let item" class="table-content">{{item.dsName}}</td>
          </ng-container>


          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef class="table-header">ESTADO</th>
            <td mat-cell *matCellDef="let item" class="table-content">
              <p [style.color]="item.isActive ? 'blue' : '#F44336'">{{item.isActive | status}}</p>
            </td>
          </ng-container>

          <ng-container matColumnDef="statusBtn">
            <th mat-header-cell *matHeaderCellDef class="table-header">Cambiar estado</th>
            <td mat-cell *matCellDef="let item" class="table-content">
              <button mat-flat-button [ngClass]="{'activate-btn': !item.isActive, 'deactivate-btn': item.isActive}"
                (click)="openDialog(false, item.cdItem, item.isActive, item.cdItemsCategory)">
                {{item.isActive | changeStatus}}</button>
            </td>
          </ng-container>

          <ng-container matColumnDef="banner">
            <th mat-header-cell *matHeaderCellDef class="table-header">agregar a banner</th>
            <td mat-cell *matCellDef="let item" class="table-content">
              <mat-slide-toggle [(ngModel)]="item.isBanner" (ngModelChange)="bannerChange($event, item.cdItem)">
              </mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="opcion">
            <th mat-header-cell *matHeaderCellDef class="table-header">OPCIONES</th>
            <td mat-cell *matCellDef="let item" class="table-content">
              <button mat-mini-fab class="link-btn"
                (click)="addOptional(item.dsName, item.cdItem, item.cdItemOptionals)"
                  matTooltip="Agregar producto"><mat-icon>library_add</mat-icon>
              </button>
              <button mat-mini-fab class="edit-btn" (click)="editProduct(item.cdItem)"
              matTooltip="Editar producto"><mat-icon>create</mat-icon>
              </button>
              <button mat-mini-fab class="delete-btn" (click)="openDialog(true, item.cdItem, null, null)"
              matTooltip="Eliminar producto"><mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

      </mat-card>
    </section>



  </div>
</div>